/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom';
import getActiveInactiveStatus from '@product-framework/utils/getActiveInactiveStatus';

function id(original) {
  return original?.id || '';
}

function serviceProviderId(original) {
  return original?.serviceProviderId || '';
}

function createdByUserId(original) {
  return original?.createdByUserId || '';
}

function lastModifiedByUserId(original) {
  return original?.lastModifiedByUserId || '';
}

function locationName(original, props, accessorFunctionsAdditional) {
  return (
    <Link to={accessorFunctionsAdditional.navigate(original.id)}>
      {original?.locationName || ''}
    </Link>
  );
}

function locationNumber(original) {
  return original?.locationNumber || '';
}

function isDefaultLocation(original) {
  return original?.isDefaultLocation ? 'Yes' : 'No';
}

function status(original) {
  return getActiveInactiveStatus(original?.status);
}

export {
  id,
  serviceProviderId,
  createdByUserId,
  lastModifiedByUserId,
  locationName,
  locationNumber,
  isDefaultLocation,
  status,
};
